import { render, staticRenderFns } from "./EmailAutomationItem.vue?vue&type=template&id=49c4d49e&scoped=true&"
import script from "./EmailAutomationItem.vue?vue&type=script&lang=ts&"
export * from "./EmailAutomationItem.vue?vue&type=script&lang=ts&"
import style0 from "./EmailAutomationItem.vue?vue&type=style&index=0&id=49c4d49e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c4d49e",
  null
  
)

export default component.exports